import { Routes, RouterModule } from '@angular/router';
import { AdminComponent } from './admin.component';
import { AdminNavigationComponent } from './admin.navigation.component';
import { FirmwareComponent } from './firmware/admin.firmware.component';
import { FirmwareListComponent } from './firmware/admin.firmware.list.component';
import { FirmwareUploadComponent } from './firmware/admin.firmware.upload.component';
import { TestGroupComponent } from './testgroup/admin.testgroup.component';
import { TestGroupListComponent } from './testgroup/admin.testgroup.list.component';
import { TestGroupAddComponent } from './testgroup/admin.testgroup.add.component';
import { DeviceTypeComponent } from './devicetype/admin.devicetype.component';
import { DeviceTypeAddComponent } from './devicetype/admin.devicetype.add.component';
import { DeviceTypeListComponent } from './devicetype/admin.devicetype.list.component';
import { ModuleWithProviders } from '@angular/core';
import { CanActivateViaAuthGuard } from '../services/authguard.service';

const adminRoutes: Routes = [
    {
        path: 'admin',
        component: AdminComponent, 
        children: [
             {
                path: 'firmware',
                component: FirmwareComponent,
                canActivate: [CanActivateViaAuthGuard],
                children: [
                    {
                        path: '',
                        component: FirmwareListComponent
                    },
                    {
                        path: 'add',
                        component: FirmwareUploadComponent
                    }
               ]
            },
            {
                path: 'devicetype',
                component: DeviceTypeComponent,
                canActivate: [CanActivateViaAuthGuard],
                children: [
                    {
                        path: '',
                        component: DeviceTypeListComponent
                    },
                    {
                        path: 'add',
                        component: DeviceTypeAddComponent
                    }
                ]
             },            
            {
                path: 'testgroup',
                component: TestGroupComponent,
                children: [
                    {
                        path: '',
                        component: TestGroupListComponent
                    },
                    {
                        path: 'add',
                        component: TestGroupAddComponent
                    },
                    {
                        path: 'edit/:deviceType/testgroup/:testGroupName',
                        component: TestGroupAddComponent
                    }
                ],
                canActivate: [CanActivateViaAuthGuard]
            }
        ]
    },
    



    //{
    //    path: '',
    //    component: AdminComponent,
    //    children: [
    //        {
    //            path: '',
    //            component: AdminComponent,
    //            children: [
    //                {
    //                    path: 'firmware',
    //                    component: FirmwareComponent
    //                },
    //                {
    //                    path: 'systemtype',
    //                    component: SystemTypeComponent
    //                }
                    
    //            ]
    //        }
    //    ]
    //}
];
//,
//outlet: 'admincontent-outlet'
//,{ path: 'navigation', component: AdminNavigationComponent, outlet: 'navigation-outlet' }
export const appRoutingProviders: any[] = [

];

export const adminRouting: ModuleWithProviders = RouterModule.forChild(adminRoutes);


// WEBPACK FOOTER //
// ./app/admin/admin.routes.ts